module.exports = __webpack_public_path__ + "img/stop.503f587a.png";